interface Environment {
  datadog: {
    applicationId: string;
    clientToken: string;
  };
  name: string;
  urls: {
    marketingPage: string;
  };
}

const environment: Environment = {
  datadog: {
    applicationId: process.env.VITE_DATADOG_APPLICATION_ID!,
    clientToken: process.env.VITE_DATADOG_CLIENT_TOKEN!,
  },
  name: process.env.VITE_ENV_NAME!,
  urls: {
    marketingPage: process.env.VITE_MARKETING_PAGE_REDIRECT_URI!,
  },
};

export default environment;
